/**
 * Adapted version of the `react-select/src/components/Menu#MenuList` component
 * to support `id` per menu list to better target for automated tests.
 */
import React from "react";
import { PropsWithInnerRef } from "react-select/src/types";
import { MenuProps } from "react-select/src/components/Menu";
import { ReactSelectOption } from ".";

export interface InputSelectCustomMenuProps
  extends MenuProps<ReactSelectOption>,
    PropsWithInnerRef {}

export default function Menu(props: InputSelectCustomMenuProps) {
  const { children, className, cx, innerRef, innerProps, selectProps } = props;

  return (
    <div
      id={`input-select-custom-menu-${selectProps.inputId}`}
      className={
        // @ts-ignore This is an issue with the @types/react-select@3.0.4
        cx(
          // We don't support emotion in our project (you could say we're emotionless...),
          // so I'd rather not import it here, which is why the following line is commented out.
          // css(getStyles("menu", props))
          { menu: true },
          className
        ) || undefined
      }
      {...innerProps}
      ref={innerRef}
    >
      {children}
    </div>
  );
}
